import type { ReactNode } from 'react'
import { Badge } from '@/components/ui/badge'
import type { Tone } from '@/domain/lease'
import { cn } from '@/lib/utils'

// 상태 색은 셋뿐이다: 정상 · 경고 · 위험. 진행 중인 것(`none`)은 색을 쓰지 않는다.
const TONE: Record<Tone, string> = {
  ok: 'border-ok/35 bg-ok/10 text-ok-ink',
  warn: 'border-warn/50 bg-warn/15 text-warn-ink',
  danger: 'border-danger/35 bg-danger/10 text-danger-ink',
  none: 'border-border bg-transparent text-muted-foreground',
}

export function ToneBadge({
  tone,
  children,
  className,
}: {
  tone: Tone
  children: ReactNode
  className?: string | undefined
}) {
  return (
    <Badge variant="outline" className={cn('rounded-full font-normal', TONE[tone], className)}>
      {children}
    </Badge>
  )
}
